import { Supervisor } from 'core/domains/user';

export const getSupervisorInfo = (supervisor: Supervisor) => {
  const { name = '', contacts = [] } = supervisor;
  const mobilePhone = contacts.find(({ type }) => type === 'mobilePhone')?.value || '';
  const email = contacts.find(({ type }) => type === 'email')?.value || '';

  return {
    supervisorName: name,
    supervisorPhone: mobilePhone,
    supervisorEmail: email,
  };
};
